import { Button, Col, cn } from '@rematter/ui-web';
import { useSetAtom } from 'jotai';
import { LucideSquarePen, MessageSquare } from 'lucide-react';

import * as conversationListState from '../_state/conversationList.state';
import { useTranslations } from '../i18n/useTranslations';

export const NoConversation = () => {
  const t = useTranslations();

  const createConversation = useSetAtom(
    conversationListState.$createConversation,
  );

  return (
    <Col xCenter yCenter className={cn('@NoConversation', 'h-full px-10')} gap6>
      <div className="rounded-full bg-primary/5 p-5">
        <MessageSquare className="size-10 text-primary/60" />
      </div>
      <Col xCenter gap1>
        <h3 className="text-xl font-semibold text-neutral/90">
          {t.noConversation.welcome}
        </h3>
        <p className="text-center text-neutral/50">
          {t.noConversation.selectConversation}
        </p>
      </Col>
      <Button onClick={createConversation} icon={<LucideSquarePen />}>
        {t.noConversation.startNew}
      </Button>
    </Col>
  );
};
